export const getHeaderSP = (selected, deductions) => {
  const { payrollTypes, jobTypeVal, payItems } = selected;
  const { incentives = [], otherInfo = {} } = deductions;

  const additionalHeader = incentives.flatMap((item) =>
    (item?.otherAdditionals ?? []).map((allowance) => ({ label: allowance?.name }))
  );
  const deductionHeader = incentives.flatMap((item) =>
    (item?.otherDeductions ?? []).map((allowance) => ({ label: allowance?.name }))
  );

  const allowanceName = payrollTypes === "SP" ? payItems : "";

  const commonHeaders = [
    { label: "Employee Number" },
    {
      label: jobTypeVal === "Job Order" ? "ACCOUNT NUMBER" : "ACCT NO.",
    },
    { label: "LAST NAME" },
    { label: "FIRST NAME" },
    { label: "MIDDLE NAME" },
  ];

  const earnedPeriodHeader = (month) => ({
    // Keep base label for convertLabels → earnedForThePeriod / earnedForThePeriod2
    label: "EARNED FOR THE PERIOD",
    displayLabel: month
      ? `EARNED FOR THE PERIOD (${month})`
      : "EARNED FOR THE PERIOD",
  });

  if (payItems === "20% Monthly Premium") {
    return [
      [
        { label: "SEQUENCE" },
        ...commonHeaders,
        earnedPeriodHeader(otherInfo?.monthFrom),
        ...(otherInfo?.monthTo !== ""
          ? [earnedPeriodHeader(otherInfo?.monthTo)]
          : []),
        { label: "TOTAL EARNED" },
        { label: "20% EARNED AMOUNT" },
        { label: "3%" },
        { label: "NET PAY" },
      ],
      [],
    ];
  }

  const headerMap = {
    [payItems]: [
      { label: "SEQUENCE" },
      ...commonHeaders,
      ...additionalHeader,
      ...deductionHeader,
      { label: "NET PAY" },
    ],
    DEFAULT: [...commonHeaders],
  };

  if (allowanceName in headerMap) {
    return [headerMap[allowanceName], []];
  } else {
    return [[], [], []];
  }
};
